export const uploadFile = async function (file: Blob) {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const { data } = await fetch(process.env.REACT_APP_IMAGE_UPLOAD_ENDPOINT as string, {
      method: 'POST',
      body: formData,
    }).then((response) => response.json());
    console.log('[uploadFile:response]', data);

    return data;
  } catch (e) {
    console.error('[uploadFile]', e);
    throw e;
  }
};
